import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'privacy' | 'terms'>('privacy');
  const openModal = (type: 'privacy' | 'terms') => {
    setModalContent(type);
    setModalOpen(true);
  };
  const privacyContent = <>
      <p data-id="element-118">
        <strong data-id="element-119">1. Información que recopilamos</strong>
        <br data-id="element-120" />
        Recopilamos información necesaria para procesar su compra y entregar el
        producto digital, incluyendo nombre y correo electrónico. No almacenamos
        información financiera completa.
      </p>

      <p data-id="element-121">
        <strong data-id="element-122">2. Uso de la información</strong>
        <br data-id="element-123" />
        Utilizamos su información únicamente para entregar el producto, enviar
        actualizaciones relacionadas y mejorar nuestros servicios.
      </p>

      <p data-id="element-124">
        <strong data-id="element-125">3. Protección de datos</strong>
        <br data-id="element-126" />
        Implementamos medidas de seguridad estándar de la industria para
        proteger su información personal contra acceso no autorizado.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-127">
        <strong data-id="element-128">1. Aceptación</strong>
        <br data-id="element-129" />
        Al comprar este producto, usted acepta estos términos y condiciones en
        su totalidad.
      </p>

      <p data-id="element-130">
        <strong data-id="element-131">2. Producto digital</strong>
        <br data-id="element-132" />
        "El Apoyo Incondicional" es un producto 100% digital. No se enviará
        ningún producto físico.
      </p>

      <p data-id="element-133">
        <strong data-id="element-134">3. Política de reembolso</strong>
        <br data-id="element-135" />
        Ofrecemos una garantía de satisfacción total. Si no está satisfecho,
        puede solicitar un reembolso completo.
      </p>
    </>;
  return <>
      <footer className="bg-[#1A1035] text-[#9CA3AF] text-center py-[40px] px-[15px] text-[12px] border-t border-[#2D1B69]" data-id="element-136">
        <p className="mb-4 text-[14px] font-medium text-white" data-id="element-137">
          © 2025 - El Apoyo Incondicional
        </p>
        <div className="flex justify-center gap-6 text-[12px]" data-id="element-138">
          <button onClick={() => openModal('privacy')} className="hover:text-white underline transition-colors" data-id="element-139">
            Política de Privacidad
          </button>
          <button onClick={() => openModal('terms')} className="hover:text-white underline transition-colors" data-id="element-140">
            Términos y Condiciones
          </button>
        </div>
        <p className="mt-8 text-[10px] opacity-50 max-w-[400px] mx-auto" data-id="element-141">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>

      <LegalModal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} content={modalContent === 'privacy' ? privacyContent : termsContent} data-id="element-142" />
    </>;
}